import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./app";
import "react-phone-number-input/style.css";
import "./index.css";
import "./desktop.css";
import { YMInitializer } from "react-yandex-metrika";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <YMInitializer accounts={[98839929]} version="2" />
    <App />
  </React.StrictMode>,
);
